import { Component, OnInit, Input,Output,EventEmitter } from '@angular/core';
import{LoopBackAuth, listadosService, rolesService} from '../services/api-rest.service';
import{MessageService} from '../services/message.service';
import { ToastrService } from 'ngx-toastr';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ModalMensajeUsuarioComponent } from '../modal/modal-mensaje-usuario/modal-mensaje-usuario.component';

@Component({
  selector: 'selector-empresa-sucursal-rol',
  template: `
    <div class="col-sm-4">
      <div class="input-group input-group-sm mb-0">
          <select
          name="alumnoTipo"
          class="form-control"
          [disabled]="activar"
          [(ngModel)]="seleccionar.empresa"
          (change)="changeEmpresa()">
          <option value="null">SELECCIONE EMPRESA</option>
          <option *ngFor="let item of empresas" [value]="item.id">{{item.descripcion | uppercase}}</option>
        </select>
      </div>
    </div>
    <div class="col-sm-3 pl-0 pr-0">
      <div class="input-group input-group-sm mb-0">
          <select
          name="alumnoTipo"
          class="form-control"
          [disabled]="activar"
          [(ngModel)]="seleccionar.pventa">
          <option value="null">SELECCIONE SUCURSALES</option>
          <option *ngFor="let item of sucursalesPventa" [value]="item.adm_ptoventa_id">{{'['+ item.serie1_inv + item.serie2_inv +'] - '+ item.adm_sucursal_descripcion+' - '+item.adm_ptoventa_descripcion | uppercase}}</option>
        </select>
      </div>
    </div>
    <div class="col-sm-3">
          <div class="input-group input-group-sm mb-0">
              <select
              name="alumnoTipo"
              class="form-control"
              [(ngModel)]="seleccionar.rol">
              <option value="null">SELECCIONE ROL</option>
              <option *ngFor="let item of roles" [value]="item.id">{{item.descripcion | uppercase}}</option>
            </select>
          </div>
    </div>
    <div class="col-sm-2">
      <button type="button" class="btn btn-primary p-2 f-12" style="font-size: 12px;" (click)="save()">
        <i class="icofont icofont-plus"></i> Agregar
      </button>
    </div>
  `,
  providers:[LoopBackAuth, listadosService,MessageService, rolesService]
})
export class SelectorEmpresaSucursalRolComponent implements OnInit {
  @Input() seleccionar
  @Input() activar: boolean
  @Input() idUsuario
  @Output() emitterSave  = new EventEmitter()
  empresasSucursales: any
  empresas: any
  sucursalesPventa: any
  roles:any
  constructor(
    private listadosService:listadosService,
    private rolesService:rolesService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.listadosService.roles().subscribe(
      lista =>{
        this.roles = lista
      }
    )
    this.listadosService.empresaSucursal().subscribe(
      lista =>{
        if(lista != null){
          let empresas = []
          this.empresasSucursales = lista
          console.log("ricardo",lista)
          for (let item  of lista){
            let count =0
            for(let empresa of empresas){
              if(item.adm_empresa_id == empresa.id) count++
            }
            if(count == 0) empresas.push({id: item.adm_empresa_id, descripcion: item.adm_empresa_razon_social})
          }
          this.empresas = empresas
        }
    })
  }
  changeEmpresa(){
    this.sucursalesPventa = this.empresasSucursales.filter(item => item.adm_empresa_id == this.seleccionar.empresa)
    
  }

  validar(){
    let index = this.empresasSucursales.findIndex(elemen =>elemen.adm_ptoventa_id == this.seleccionar.pventa)
    if(
      this.seleccionar.pventa == null || 
      this.seleccionar.rol == null || 
      this.empresasSucursales[index].jornada_aca_curso_jornada_id == null ||
      this.empresasSucursales[index].seccion_aca_curso_seccion_id == null){
        const ventana = this.modalService.open(ModalMensajeUsuarioComponent)
        ventana.componentInstance.mensaje = "No selecciono Empresa o Sucursal"
        ventana.componentInstance.icono = 'icofont icofont-document-search'
        return false
    }

    return true
  }
  save(){
    if(this.validar()){
      let index = this.empresasSucursales.findIndex(elemen =>elemen.adm_ptoventa_id == this.seleccionar.pventa)
      this.rolesService.asignarRolesUsuario(
        this.idUsuario,this.seleccionar.pventa,
        this.seleccionar.rol,
        this.empresasSucursales[index].jornada_aca_curso_jornada_id,
        this.empresasSucursales[index].seccion_aca_curso_seccion_id).subscribe(
        item=>{
          if(item != null){
            this.toastr.success("Agrego el Rol","ÉXITO")
            this.emitterSave.emit()
          }else{
            const ventana = this.modalService.open(ModalMensajeUsuarioComponent)
            ventana.componentInstance.mensaje = "El rol seleccionado ya esta asignado"
            ventana.componentInstance.icono = 'icofont icofont-document-search'
          }
          
        }
      )
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/selector-empresa-sucursal-rol.component.ts